import {Component, EventEmitter, forwardRef, Input, Output} from "@angular/core";
import {AddRowActionComponent} from "./add-row-action.component";

@Component({
    selector: "wbo-edit-grid-add-row-custom",
    template: "",
    providers: [
        {provide: AddRowActionComponent, useExisting: forwardRef(() => EditGridAddRowCustomComponent), multi: true}
    ]
})
export class EditGridAddRowCustomComponent extends AddRowActionComponent {
    @Input() title: string = "wbo.edit.grid.add.addNew";
    @Output() onAdd: EventEmitter<void> = new EventEmitter();

    override click(): void {
        this.onAdd.emit()
    }
}
